<div class="nt-field" style="padding-top:3px">
    <mat-form-field class="ex">
        <input matInput type="text" #tfInput [(ngModel)]="init_text_value" (ngModelChange)="updateValue($event)"
            autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off">
    </mat-form-field>
</div>

<!-- The suggestion list is the shared one (suggest-list.ts): it owns its own panel, its
     own CSS and its own key handling, and appends to <body> so a dialog's overflow cannot
     clip it the way it clipped the mat-autocomplete overlay this replaced. -->

<div *ngIf="showButton" class="panel panel-default" style="align-items: right; border: NONE; padding: 2px;">
    <button *ngIf="showButton" type="button" class="btn btn-outline-secondary btn-sm" (click)="apply( taparam.value )">
        {{button_label}}
    </button>
</div>
